import { NavigationItem } from '../types';
import { useTheme } from '@mui/material/styles';
import Button from '@mui/material/Button';
import ExpandMoreRoundedIcon from '@mui/icons-material/ExpandMoreRounded';
import { styles } from '../constants';

export default function DesktopMenuButton({
  menuHeader,
  onMenuClick,
  onMenuEnter,
  openMenuIndex,
  isMenuOpen,
  index,
}: {
  menuHeader: NavigationItem;
  onMenuClick: (index: number) => void;
  onMenuEnter: (index: number) => void;
  openMenuIndex: number | null;
  isMenuOpen: boolean;
  index: number;
}) {
  const theme = useTheme();
  const isCurrentMenuOpen = isMenuOpen && openMenuIndex === index - 1;

  return (
    <Button
      key={`menu-${index}`}
      onClick={() => onMenuClick(index - 1)}
      onMouseEnter={() => onMenuEnter(index - 1)}
      endIcon={
        <ExpandMoreRoundedIcon
          sx={{
            transform: isCurrentMenuOpen ? 'rotate(180deg)' : 'rotate(0deg)',
            transition: theme.transitions.create('transform'),
            fontSize: '1rem',
          }}
        />
      }
      variant='text'
      sx={styles.desktopMenuButton}
    >
      {menuHeader.title}
    </Button>
  );
}
